export const LEGAL_COMPANY_NAME = 'FACT LTDA';
export const LEGAL_COMPANY_DOCUMENT = '49.881.122/0001-23';
export const LEGAL_COMPANY_LOCATION = 'Arapiraca, AL - Brasil';
export const LEGAL_CONTACT_EMAIL =
  process.env.LEGAL_CONTACT_EMAIL ?? 'contato@fact-labs.com';
export const LEGAL_DOCUMENT_VERSION = '0.0.1';
export const LEGAL_DOCUMENT_UPDATED_AT = '25 de setembro de 2026';

export const INTELLECTUAL_PROPERTY_UPDATED_AT = '1 de outubro de 2026';

export const INTELLECTUAL_PROPERTY_NOTICES = [
  {
    game: 'Yu-Gi-Oh!',
    rightsHolderName: 'KONAMI',
    rightsNotice:
      'Yu-Gi-Oh! © KONAMI. Yu-Gi-Oh! e todos os nomes, imagens, ilustrações e marcas relacionadas pertencem aos seus respectivos titulares.',
    independenceNotice:
      'NexoTCG é um marketplace independente e não possui afiliação, patrocínio ou endosso da KONAMI.',
    imagePurposeNotice:
      'Imagens de cartas são utilizadas para identificação dos produtos comercializados na plataforma.',
    pageImagePurposeNotice:
      'As imagens de cartas exibidas no catálogo e nas ofertas da plataforma são utilizadas com a finalidade de identificar os produtos físicos anunciados por vendedores e facilitar sua localização pelos usuários.',
  },
] as const;
